import React from 'react';
import { Mail, CheckCircle } from 'lucide-react';
import { Button } from '../common/Button';
import Modal from '../common/Modal';

interface TrialRequestModalProps {
  visible: boolean;
  onClose: () => void;
  planName?: string;
  userLocation?: { country: string; countryCode: string } | null;
}

const TrialRequestModal: React.FC<TrialRequestModalProps> = ({ 
  visible, 
  onClose, 
  planName,
  userLocation 
}) => {
  return (
    <Modal 
      isOpen={visible} 
      onClose={onClose} 
      title="Trial Request Submitted!"
      maxWidth="440px"
    >
      <div className="p-6">
        <div className="flex flex-col items-center">
          <div className="bg-green-500/10 rounded-full p-4 mb-4">
            <CheckCircle size={32} className="text-green-500 animate-pulse" />
          </div>
          
          <p className="text-sm text-text-secondary-light dark:text-text-secondary-dark text-center mb-4">
            {planName ? `Your ${planName} trial request` : 'Your trial request'} has been successfully submitted.
          </p>
          
          <div className="flex items-center justify-center mb-4 p-3 bg-blue-500/10 dark:bg-blue-400/10 rounded-lg w-full">
            <Mail size={20} className="text-blue-500 dark:text-blue-400 mr-3" />
            <div className="text-left">
              <p className="text-sm font-medium text-text-primary-light dark:text-text-primary-dark">
                We'll get back to you via email
              </p>
              <p className="text-xs text-text-secondary-light dark:text-text-secondary-dark">
                {userLocation?.country && userLocation.country !== 'India' 
                  ? `with special pricing for ${userLocation.country}` 
                  : 'with more details about your trial'}
              </p>
            </div>
          </div>
          
          <p className="text-xs text-text-secondary-light dark:text-text-secondary-dark text-center mb-6">
            Expected response time: <span className="text-text-primary-light dark:text-text-primary-dark font-medium">24-48 hours</span>
          </p>
          
          <Button
            variant="primary"
            size="md"
            className="w-full"
            onClick={onClose}
          >
            Got it, thanks!
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default TrialRequestModal; 